module.exports = __webpack_public_path__ + "emoji.svg?28e3cfe4074cb098cd6671d080796f0e";